import { _ } from '../../vendor'

import InboomaBaseFilterableCollection from './InboomaBaseFilterableCollection'

import Product from '../models/Product'

export default InboomaBaseFilterableCollection.extend({

    collectionName : 'products',
    model : Product,
    url : '/products',



    _pagination : {
        current_page : 0,
        sort : 'name',
        sortDirection : 'asc',
        has_next_page : false,
        has_prev_page : false,
        count : 0,
        limit : 100
    },

    _filterParams : {},

});